export default {"src":"https://web.cdn.greenlight.com/2.196.3/_next/static/media/unordered-list-green-check.22d77997.svg","height":16,"width":20};